import { render, staticRenderFns } from "./DetailVote.vue?vue&type=template&id=597859f0&scoped=true"
import script from "./DetailVote.vue?vue&type=script&lang=js"
export * from "./DetailVote.vue?vue&type=script&lang=js"
import style0 from "./DetailVote.vue?vue&type=style&index=0&id=597859f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597859f0",
  null
  
)

export default component.exports